import { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { useAuth0 } from '@auth0/auth0-react';
import { AnonymousUserToken } from '@enterprise/common';
import AppStore from '../../store/AppStore';
import { RouterStore } from '../../store';
import { RouterPaths } from '../../router/RouterPaths';

interface ILogoutProps {
    app?: AppStore;
    routing?: RouterStore;
}

const LogoutPage = inject('app', 'routing')(
    observer(function LogoutPage({ app, routing }: ILogoutProps) {
        const { isLoading } = useAuth0();

        useEffect(() => {
            (app as AppStore).token = new AnonymousUserToken();

            if (isLoading) {
                return;
            }

            (routing as RouterStore).push(RouterPaths.BasePages.Root);
        }, [isLoading]);

        return <div>Loading...</div>;
    }),
);

export default LogoutPage;
